import { createContext } from 'react'

// Carries the (municipality, section) column list down through the
// recursive tree so LeafPredicateForm can render real column dropdowns
// without prop-drilling through every TreeNode.
//
// Shape:
//   {
//     columns: [{ id, name, database_column_name, display_as,
//                 description, system_display_name }, ...],
//     isLoading: bool,
//     auditColumns: { param_name: database_column_name } | null
//   }
//
// `auditColumns` is set only for audit-log sections; when present the form
// hides the column params it fills (the section supplies them at run time).
const RecipeBuilderContext = createContext({ columns: [], isLoading: false, auditColumns: null })

export default RecipeBuilderContext
